import { render, staticRenderFns } from "./Tvs.vue?vue&type=template&id=065638b8&scoped=true&"
import script from "./Tvs.vue?vue&type=script&lang=js&"
export * from "./Tvs.vue?vue&type=script&lang=js&"
import style0 from "./Tvs.vue?vue&type=style&index=0&id=065638b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065638b8",
  null
  
)

export default component.exports